import "rc-slider/assets/index.css";
import "./styles.css";

import { mountReactComponent, parseJsonValue } from "@siisel/frontend-shared";
import App from "./components/App";
import { ensureChartJsSetup } from "./config/chartJsSetup";
import type { ChartsRootProps, RootModule } from "./types";

ensureChartJsSetup();

const ROOT_SELECTOR = "[data-charts-app-root='true'], #root";
const ROOT_MODULES: RootModule[] = [
  "measurement-chart",
  "measurement-chart-group",
  "profile",
  "axis-charts",
  "chainage-chart",
  "chart-type-select"
];

function detectModule(element: HTMLElement): RootModule | null {
  const moduleName = (element.dataset.module ?? element.dataset.component ?? "") as RootModule;
  return ROOT_MODULES.includes(moduleName) ? moduleName : null;
}

function getProps(element: HTMLElement): ChartsRootProps | null {
  const moduleName = detectModule(element);
  if (!moduleName) {
    return null;
  }

  return {
    module: moduleName,
    args: parseJsonValue<unknown>(element.dataset.componentArgs, element.id || "ChartsApp") ?? {}
  };
}

mountReactComponent<ChartsRootProps>({
  Component: App,
  getProps,
  mountedDataKey: "chartsAppMounted",
  selector: ROOT_SELECTOR
});
